import { HttpClient } from './http-client';
import { 
  DivisionRole,
  DivisionRoleListResponse,
  CreateDivisionRoleRequest,
  UpdateDivisionRoleRequest
} from '../types';

export class DivisionRoleService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get all roles for a specific division
   */
  async getDivisionRoles(divisionId: string): Promise<DivisionRoleListResponse> {
    return this.httpClient.get<DivisionRoleListResponse>(
      `/api/v1/divisions/${divisionId}/roles`
    );
  }

  /**
   * Get a specific division role by ID
   */
  async getDivisionRole(divisionId: string, roleId: string): Promise<DivisionRole> {
    return this.httpClient.get<DivisionRole>(
      `/api/v1/divisions/${divisionId}/roles/${roleId}`
    );
  }

  /**
   * Create a new division role
   */
  async createDivisionRole(
    divisionId: string, 
    request: CreateDivisionRoleRequest
  ): Promise<DivisionRole> {
    return this.httpClient.post<DivisionRole>(
      `/api/v1/divisions/${divisionId}/roles`,
      request
    );
  }

  /**
   * Update an existing division role
   */
  async updateDivisionRole(
    divisionId: string,
    roleId: string,
    request: UpdateDivisionRoleRequest
  ): Promise<DivisionRole> {
    return this.httpClient.put<DivisionRole>(
      `/api/v1/divisions/${divisionId}/roles/${roleId}`,
      request
    );
  }

  /**
   * Delete a division role
   */
  async deleteDivisionRole(divisionId: string, roleId: string): Promise<void> {
    return this.httpClient.delete<void>(
      `/api/v1/divisions/${divisionId}/roles/${roleId}`
    );
  }
}
